import React from 'react'
import './Navbar.css'
import Toggle from '../Toogle/Toggle'
import { Link } from 'react-scroll'



const Navbar = () => {
    return (
        <div className="nWrapper">
            <div className="navLeft">
                <div className="navName">Praddyota</div>
                <Toggle />
            </div>
            <div className="navRight">
                <div className="navList">
                    <ul style={{ listStyleType: 'none' }}>
                        <Link spy={true} to='Navbar' smooth={true} activeClass='activeClass'>
                            <li>Home</li>
                        </Link>
                        <Link spy={true} to='Services' smooth={true}>
                            <li>Services</li>
                        </Link>
                        <Link spy={true} to='Experience' smooth={true}>
                            <li>Experience</li>
                        </Link>
                        <Link spy={true} to='Work' smooth={true}>
                            <li>Work</li>
                        </Link>
                        <Link spy={true} to='Portfolio' smooth={true}>
                            <li>Portfolio</li>
                        </Link>
                        <Link spy={true} to='Testimonials' smooth={true}>
                            <li>Testimonials</li>
                        </Link>
                    </ul>
                </div>

                <button className="button navButton">Contact</button>
            </div>
        </div>
    )
}

export default Navbar